import _ from 'lodash';
import {serverVisitToClientMap, serverUnitToClientMap, serverUnitsToClientMap, serverDocToClientMap, serverGoodToClientMap} from './serverToClientMap';
import {clientVisitToServerMap, clientUnitToServerMap, clientGoodToServerMap, clientDocToServerMap} from './clientToServerMap';
import defaultUnitFieldValues from './defaultUnitFieldValues';
import * as VERIFY_STATUS from 'modules/visits/constants/unitVerificationStatus';
import iso6346Check from "../lib/iso6346Check";
import { UNIT_KINDS } from '../globals';

const showUnitFieldCustomCheck = (formFields, fieldName, unitVerification) => {
    switch (fieldName){
        case 'pos':
        case 'dim':
            return formFields.trac.value || unitVerification.status === VERIFY_STATUS.VERIFIED_OK || unitVerification.dims.length > 0;
        case 'netto':
            return formFields.empty.value === '0' && (formFields.trac.value || unitVerification.status === VERIFY_STATUS.VERIFIED_OK || unitVerification.dims.length > 0);
        case 'goodsOverview':
        case 'docsOverview':
            return !!formFields.trac.value;
        default:
            return true;
    }
};

export const unitKindHasISO = _.memoize((unitKind) => {
    const unitKindsWithISO = ['C'];
    return _.indexOf(unitKindsWithISO,unitKind) >= 0;
});

export const dropOffOnly = _.memoize((fieldName) => {
    const fieldsForDropOff = ['pos', 'ISO', 'dim', 'unitKind', 'goods', 'documents', 'netto', 'rid'];
    return _.indexOf(fieldsForDropOff,fieldName) >= 0;
});

export const pickUpOnly = _.memoize((fieldName) => {
    const fieldsForPickUp = ['pos', 'dim'];
    return _.indexOf(fieldsForPickUp,fieldName) >= 0;
});

export const showDropOffUnitField = (formFields, fieldName) => {
    if (fieldName === 'goodsOverview' || fieldName === 'docsOverview') {
        return true;
    }

    return dropOffOnly(fieldName);
};

export const showVerifyButton = (formFields) => {
    if (formFields.inOut.value === 'I' && !formFields.ctNumber.value) {
        return false;
    } else if (formFields.inOut.value === 'I' && formFields.unitKind.value === UNIT_KINDS.CONTAINER && !iso6346Check(formFields.ctNumber.value)) {
        return false;
    }

    // Not saved
    if (!formFields.trac.value) {
        if (formFields.inOut.value === 'O') {
            return (formFields.reference.value || formFields.ctNumber.value)
                && formFields.inOut.value
                && formFields.empty.value;
        }

        // reference, inOut and empty value given
        return formFields.reference.value
            && formFields.inOut.value
            && formFields.empty.value;
    }

    // saved
    // + dirty form
    return formFields.reference.dirty
        || formFields.inOut.dirty
        || formFields.empty.dirty
        || formFields.unitKind.dirty
        || formFields.ctNumber.dirty
        || formFields.rid.dirty;
};

export const showSaveUnitButton = (formFields, unitVerification) => {
    return unitVerification.status === VERIFY_STATUS.VERIFIED_OK || formFields.trac.value;
};

export const showUnitField = (formFields, fieldName, unitVerification) => {
    return (formFields.inOut.value === 'I' && showDropOffUnitField(formFields, fieldName) ||
        formFields.inOut.value === 'O' && pickUpOnly(fieldName)) && showUnitFieldCustomCheck(formFields, fieldName, unitVerification);
};

export const showDocField = (formFields, fieldName) => {
    if (formFields.type.value && ['ZD', 'GOODS', 'UNIT'].indexOf(formFields.type.value.trim()) > -1) {
        return (['number', 'regPlace', 'regDate'].indexOf(fieldName)) === -1;
    }
    return true;
};

export {serverVisitToClientMap, serverUnitToClientMap, serverUnitsToClientMap, serverDocToClientMap, serverGoodToClientMap,
    clientVisitToServerMap, clientUnitToServerMap, clientGoodToServerMap, clientDocToServerMap,
    defaultUnitFieldValues};
